import { useCallback, useState } from 'react';
import type * as customEventConstants from '../../constants/customEventConstants';
import { publish } from '../../utils/customEvent';

type CustomEventConstantsType = (typeof customEventConstants)[keyof typeof customEventConstants];

export const useToggle = (
  initState = false,
  eventName?: CustomEventConstantsType,
  publishEvent = false,
) => {
  const [isOpen, setIsOpen] = useState(initState);

  const handleOpen = useCallback(() => {
    setIsOpen(true);
  }, [setIsOpen]);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleToggle = () => {
    setIsOpen((prevIsOpen) => !prevIsOpen);
    if (publishEvent && eventName) {
      publish(eventName, { isOpen });
    }
  };

  return { isOpen, handleOpen, handleClose, handleToggle };
};
